import { useEffect, useState } from 'react';

/** Minimal hash router — no dependency, SPA-friendly on S3 + CloudFront. */
export function useHashRoute(): string {
  const [route, setRoute] = useState<string>(
    () => window.location.hash.slice(1) || '/',
  );
  useEffect(() => {
    const onChange = () => setRoute(window.location.hash.slice(1) || '/');
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);
  return route;
}

export function navigate(to: string): void {
  window.location.hash = to;
}
